import logo from './icon_logo.png'

export const icons = {
  LOGO: logo
}
